import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DashboardNav from "./DashboardNav/DashboardNav";
import DBAdmin from "./Admin/DBAdmin";
import DBInhouse from "./InHouse/DBInhouse";
import DBLogin from "./DBLogin.js";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "firebaseClient";

import "./Dashboard.css";
import { BackProvider } from "context/BackContext";
function Dashboard() {
  const [searchParams] = useSearchParams();
  const view = searchParams.get("view") || "inhouse";

  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthenticated(!!user);
    });
    return unsubscribe;
  }, []);

  return (
    <div className="dashboard-wrapper">
      <BackProvider>
        <DashboardNav currentView={view} authenticated={authenticated} />
        <div className="db-background">
          {!authenticated ? (
            <DBLogin setAuthenticated={setAuthenticated} />
          ) : (
            (view === "admin" && <DBAdmin />) ||
            (view === "inhouse" && <DBInhouse />)
          )}
        </div>
      </BackProvider>
    </div>
  );
}

export default Dashboard;
